export var ACTION;
(function (ACTION) {
    ACTION["TRANSACTION"] = "TRANSACTION";
    ACTION["NAVIGATION"] = "NAVIGATION";
    ACTION["EMAIL"] = "EMAIL";
    ACTION["ENHANCE_LIMIT"] = "ENHANCE_LIMIT";
    ACTION["MARGIN_CALL"] = "MARGIN_CALL";
    ACTION["MENU"] = "MENU";
    ACTION["UNPLEDGE"] = "UNPLDEGE";
    ACTION["VERIFY_OTP"] = "VERIFY_OTP";
    ACTION["NAVIGATE_DASHBOARD"] = "NAVIGATE_DASHBOARD";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["EDIT_BUTTON_ACTION"] = "EDIT_BUTTON_ACTION";
    ACTION["NAVIGATE_TO_LANDING_PAGE"] = "NAVIGATE_TO_LANDING_PAGE";
})(ACTION || (ACTION = {}));
